export default function getShipmentStatus(status) {
  if (!status) {
    return "-";
  }

  switch (status) {
    case "ارجاع به راننده":
      return "ارجاع به راننده";

    case "برگشتی":
      return "برگشتی";

    case "تحویل داده شده":
      return "تحویل سرویس دهنده (در حال جابجایی)";

    case "تحویل مشتری":
      return "تحویل مشتری";

    case "جمع آوری نشده":
      return "جمع آوری نشده";

    case "لغو شده":
      return "لغو شده";

    case "لغو موقت":
      return "لغو موقت";

    case "معلق":
      return "بر صف پردازش (آماده ارسال)";

    default:
      return "-";
  }
}
